module.exports = __webpack_public_path__ + "img/bus-sentosa.e0f29e00.svg";